module.exports = __webpack_public_path__ + "static/media/iconFilter.3460b57d.svg";